module.exports = __webpack_public_path__ + "img/display_blomstrande_liv.ad644a9a.png";